// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 954) return "subsite-china/954-35ad39b868d42d3c9062.js";
	if (chunkId === 532) return "subsite-china/styles-4eaeceb620afdd1ebc91.js";
	if (chunkId === 351) return "subsite-china/commons-8bb07e4653eb121283ce.js";
	if (chunkId === 875) return "subsite-china/190f48e1d712abf1b23afe7d98d0424ba15cabee-61e5c72e5cca56ddacbd.js";
	if (chunkId === 218) return "subsite-china/component---src-pages-404-tsx-7e5245ca2ae14d723308.js";
	if (chunkId === 278) return "subsite-china/b0c88c5e5b54854a066ab8be45f25781c5307858-1dbb8e421f2b2bc12c2c.js";
	if (chunkId === 904) return "subsite-china/2d1c9d34d7cabdcdf27eb8ffad16bade3b93f9b1-dc7dee58f52ede48f05a.js";
	if (chunkId === 660) return "subsite-china/component---src-templates-personal-area-calendar-page-index-tsx-0725b2fefeccbf4e84b0.js";
	if (chunkId === 456) return "subsite-china/8bd7444894d603c816394f87921cda61ce72b74b-eb07d5b69bb50d7fd5a0.js";
	if (chunkId === 874) return "subsite-china/component---src-templates-personal-area-profile-page-index-tsx-6a92ef2c19d732d3ce42.js";
	if (chunkId === 323) return "subsite-china/component---src-templates-qr-index-tsx-7b5df7a98e224c0e74a2.js";
	if (chunkId === 77) return "subsite-china/component---src-templates-search-page-index-tsx-6125f11076c2e2df778a.js";
	if (chunkId === 737) return "subsite-china/fb7d5399-cf096f94b49f50359935.js";
	if (chunkId === 863) return "subsite-china/072d4843-95097c8b0354df9d7856.js";
	if (chunkId === 208) return "subsite-china/2aacc723-afc0e5405847657bcb5f.js";
	if (chunkId === 344) return "subsite-china/bf322c48-70ea7c3d3e6f22c879c4.js";
	if (chunkId === 811) return "subsite-china/22e32791-84ee619bbb442e760648.js";
	if (chunkId === 312) return "subsite-china/409a021e-c521cdab044dce2a244f.js";
	if (chunkId === 125) return "subsite-china/b2d36f25-be6078c592f1ccfe8b03.js";
	if (chunkId === 255) return "subsite-china/7d0bf13e-41d56971c431fd2b3b43.js";
	if (chunkId === 330) return "subsite-china/component---src-templates-standard-page-index-tsx-836d9feb57ef3d658663.js";
	if (chunkId === 731) return "subsite-china/731-70f92d5f3e87d753c3b0.js";
	if (chunkId === 843) return "subsite-china/843-af3b3541d8a1de72e783.js";
	// return url for filenames based on template
	return undefined;
};